/* eslint-disable max-len -- Keep translation catalogue sentences together. */
export const labels = {
  en: {
    title: 'Current usage and purchased capacity',
    active: 'Enabled logins',
    inactive: 'Inactive HR records',
    purchasedActive: 'Purchased active seats',
    purchasedInactive: 'Purchased inactive capacity',
    activeRate: 'Active rate',
    inactiveRate: 'Inactive rate',
    retained:
      'Purchased capacity is reusable. Lower usage does not automatically reduce the subscription or change previous invoices.',
    policy: 'Billing policy draft',
    note: 'Save a new version for review. Saving does not activate pricing, qualify provider capabilities or change the subscription.',
    save: 'Save draft',
    saved: 'Draft saved for review.',
    failed:
      'The draft could not be saved. Your entries are retained. Try again; if it still fails, contact your billing administrator.',
    invalid: 'Check the rates, period and required approved references. Select an existing provider mapping.',
    rateInvalid: 'The rates, currency or period do not match supported billing terms. Check the approved contract.',
    selectMapping: 'Select an existing mapping',
    mappingItems: 'Active / inactive provider items',
    mappingHelp:
      'These existing mappings belong to this subscription. Select the provider subscription and container recorded in the approved billing setup. The mapping UUID is sent automatically.',
    mappingRequired:
      'No existing provider mapping is available for this subscription. Ask your billing administrator to complete the provider mapping setup, then reopen this editor. A draft cannot create or qualify a mapping.',
    effectiveTermHelp: 'Use the approved billing date. The server validates the next uninvoiced renewal boundary.',
    lifecycleConsentReferenceHelp:
      'Enter the document ID or link recording customer approval of active/inactive pricing and retained capacity (up to 255 characters). Obtain it from the approved contract or billing approval.',
    unattendedAuthorityReferenceHelp:
      'Optional: enter the ID or link for explicit authority to buy capacity without a person confirming (up to 255 characters). Leave blank when no such authority exists.',
    sourceReferenceHelp:
      'Enter the approval ticket ID, document ID or link authorizing this policy version (up to 255 characters). Copy it from the billing approval record; do not create a placeholder.',
    loading: 'Loading billing policy…',
    unavailable: 'Billing policy is unavailable.',
    currency: 'Currency',
    exponent: 'Currency decimal places',
    unit: 'Rate period',
    count: 'Period count',
    effect: 'Effective from',
    term: 'Effective date',
    lifecycle: 'Lifecycle consent reference',
    unattended: 'Unattended authority reference (optional)',
    mapping: 'Provider mapping reference',
    source: 'Approval/source reference',
    next_uninvoiced_term: 'Next uninvoiced term',
    launch_zero: 'Launch with inactive rate zero',
    new_contract: 'New contract',
    month: 'Month',
    year: 'Year',
    week: 'Week',
    day: 'Day',
    version: 'Latest version',
    draft: 'Draft',
    qualified: 'Qualified',
    effective: 'Effective',
    superseded: 'Superseded',
    explicitZero: 'Enter 0 explicitly for free inactive records. Blank means unspecified.',
  },
  ar: {
    title: 'الاستخدام الحالي والسعة المشتراة',
    active: 'حسابات الدخول المفعلة',
    inactive: 'سجلات الموارد البشرية غير النشطة',
    purchasedActive: 'المقاعد النشطة المشتراة',
    purchasedInactive: 'السعة غير النشطة المشتراة',
    activeRate: 'سعر النشط',
    inactiveRate: 'سعر غير النشط',
    retained:
      'يمكن إعادة استخدام السعة المشتراة. لا يقل الاشتراك تلقائيًا عند انخفاض الاستخدام ولا تتغير الفواتير السابقة.',
    policy: 'مسودة سياسة الفوترة',
    note: 'احفظ إصدارًا جديدًا للمراجعة. لا يؤدي الحفظ إلى تفعيل الأسعار أو تأهيل مزود الفوترة أو تغيير الاشتراك.',
    save: 'حفظ المسودة',
    saved: 'حُفظت المسودة للمراجعة.',
    failed: 'تعذر حفظ المسودة. تم الاحتفاظ بمدخلاتك. حاول مجددًا، وإذا استمر الخطأ فتواصل مع مسؤول الفوترة.',
    invalid: 'تحقق من الأسعار والفترة ومراجع الموافقة المطلوبة، واختر ربطًا قائمًا لمزود الفوترة.',
    rateInvalid: 'الأسعار أو العملة أو الفترة لا تطابق شروط الفوترة المدعومة. تحقق من العقد المعتمد.',
    selectMapping: 'اختر ربطًا قائمًا',
    mappingItems: 'بنود المزود للنشط / غير النشط',
    mappingHelp:
      'هذه الروابط القائمة تخص هذا الاشتراك. اختر اشتراك المزود والحاوية المسجلين في إعداد الفوترة المعتمد. يُرسل معرّف الربط تلقائيًا.',
    mappingRequired:
      'لا يوجد ربط قائم متاح لهذا الاشتراك. اطلب من مسؤول الفوترة إكمال إعداد ربط المزود ثم أعد فتح المحرر. لا تنشئ المسودة ربطًا ولا تؤهله.',
    effectiveTermHelp: 'استخدم تاريخ الفوترة المعتمد. يتحقق الخادم من حد التجديد التالي غير المفوتر.',
    lifecycleConsentReferenceHelp:
      'أدخل معرّف المستند أو رابطه الذي يسجل موافقة العميل على أسعار النشط وغير النشط والاحتفاظ بالسعة (حتى 255 حرفًا). احصل عليه من العقد أو موافقة الفوترة المعتمدة.',
    unattendedAuthorityReferenceHelp:
      'اختياري: أدخل معرّف التفويض الصريح أو رابطه لشراء السعة دون تأكيد شخص (حتى 255 حرفًا). اتركه فارغًا عند عدم وجود هذا التفويض.',
    sourceReferenceHelp:
      'أدخل معرّف تذكرة الموافقة أو المستند أو رابطه الذي يجيز هذا الإصدار (حتى 255 حرفًا). انسخه من سجل موافقة الفوترة، ولا تدخل قيمة مؤقتة.',
    loading: 'جارٍ تحميل سياسة الفوترة…',
    unavailable: 'سياسة الفوترة غير متاحة.',
    currency: 'العملة',
    exponent: 'المنازل العشرية للعملة',
    unit: 'فترة السعر',
    count: 'عدد الفترات',
    effect: 'بداية السريان',
    term: 'تاريخ السريان',
    lifecycle: 'مرجع الموافقة على دورة الحياة',
    unattended: 'مرجع التفويض غير المراقب (اختياري)',
    mapping: 'مرجع ربط مزود الفوترة',
    source: 'مرجع الموافقة أو المصدر',
    next_uninvoiced_term: 'الفترة التالية غير المفوترة',
    launch_zero: 'الإطلاق بسعر صفر لغير النشط',
    new_contract: 'عقد جديد',
    month: 'شهر',
    year: 'سنة',
    week: 'أسبوع',
    day: 'يوم',
    version: 'أحدث إصدار',
    draft: 'مسودة',
    qualified: 'مؤهل',
    effective: 'ساري',
    superseded: 'مستبدل',
    explicitZero: 'أدخل 0 صراحةً للسجلات غير النشطة المجانية. الحقل الفارغ يعني غير محدد.',
  },
};

export const pricingLabels = {
  en: {
    title: 'Pricing changes',
    note: 'Save pricing changes for review. This does not apply them.',
    current: 'Current prices',
    saved: 'Saved pricing draft · Not applied',
    previous: 'Previously saved pricing draft · Not applied',
    save: 'Save draft',
    success: 'Pricing draft saved · Not applied',
    unconfirmed: 'Save not confirmed',
    unknown: 'The response could not be confirmed.',
    active: 'Active',
    inactive: 'Inactive',
    date: 'Effective date',
    count: 'Number of periods',
    select: 'Select',
    setup: {
      BILLING_POLICY_SETUP_REQUIRED: 'Billing setup is incomplete for this subscription.',
      BILLING_POLICY_SETUP_AMBIGUOUS: 'More than one billing setup matches this subscription.',
      BILLING_POLICY_CONTEXT_CHANGED: 'Billing setup has changed. Reload this subscription before saving.',
      BILLING_POLICY_CURRENCY_UNSUPPORTED: 'This currency is not supported for pricing changes.',
    },
  },
  ar: {
    title: 'تغييرات الأسعار',
    note: 'احفظ تغييرات الأسعار للمراجعة. لن يؤدي ذلك إلى تطبيقها.',
    current: 'الأسعار الحالية',
    saved: 'مسودة أسعار محفوظة · غير مطبقة',
    previous: 'مسودة أسعار محفوظة سابقًا · غير مطبقة',
    save: 'حفظ المسودة',
    success: 'تم حفظ مسودة الأسعار · غير مطبقة',
    unconfirmed: 'لم يتأكد الحفظ',
    unknown: 'تعذر تأكيد الاستجابة.',
    active: 'النشط',
    inactive: 'غير النشط',
    date: 'تاريخ السريان',
    count: 'عدد الفترات',
    select: 'اختر',
    setup: {
      BILLING_POLICY_SETUP_REQUIRED: 'إعداد الفوترة غير مكتمل لهذا الاشتراك.',
      BILLING_POLICY_SETUP_AMBIGUOUS: 'يوجد أكثر من إعداد فوترة مطابق لهذا الاشتراك.',
      BILLING_POLICY_CONTEXT_CHANGED: 'تغير إعداد الفوترة. أعد تحميل هذا الاشتراك قبل الحفظ.',
      BILLING_POLICY_CURRENCY_UNSUPPORTED: 'هذه العملة غير مدعومة لتغييرات الأسعار.',
    },
  },
};
